/* TypeScript file generated from Field.resi by genType. */

/* eslint-disable */
/* tslint:disable */

import * as FieldJS from './Field.res.js';

import type {domProps as JsxDOM_domProps} from '../../../src/shims/JsxDOM.shim';

import type {to as Navigation_to} from '../../../src/primitives/Navigation.gen';

export type Action_handler = 
    { TAG: "Callback"; _0: () => void }
  | { TAG: "OpenLink"; _0: Navigation_to }
  | { TAG: "OpenLinkNewTab"; _0: Navigation_to };

export type Action_t = { readonly text: string; readonly handler: Action_handler };

export type props<children,label,labelAriaProps,tooltip,errorMessage,action,required,ref> = {
  readonly children: children; 
  readonly label?: label; 
  readonly labelAriaProps?: labelAriaProps; 
  readonly tooltip?: tooltip; 
  readonly errorMessage?: errorMessage; 
  readonly action?: action; 
  readonly required?: required; 
  readonly ref?: ref
};

export const make: React.ComponentType<{
  readonly children: React.ReactNode; 
  readonly label?: string; 
  readonly labelAriaProps?: JsxDOM_domProps; 
  readonly tooltip?: JSX.Element; 
  readonly errorMessage?: string; 
  readonly action?: Action_t; 
  readonly required?: boolean; 
  readonly ref?: any
}> = FieldJS.make as any;
